import * as React from "react";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import { Button, Container, TextField } from "@mui/material";
import { ShippingContextType, ShipProfileContext } from "./ShippingProfile";

interface ProfileNameProps {
  handleNext: any;
  handleBack: any;
}

const AddProfileName: React.FunctionComponent<ProfileNameProps> = ({
  handleBack,
  handleNext,
}) => {
  const [profiles, setProfiles] = React.useState("");
  const { profile, setProfile } = React.useContext(
    ShipProfileContext
  ) as ShippingContextType;
  return (
    <>
      <Container maxWidth="md">
        <Box
          sx={{ display: "flex" }}
          height="60vh"
          style={{ placeContent: "center" }}
        >
          <FormControl
            sx={{ m: 2 }}
            component="fieldset"
            variant="standard"
            // style={{ alignItems: "center" }}
          >
            <FormLabel component="p" style={{ fontSize: "1.2rem" }}>
              Please Add Shipping Profile Name.
            </FormLabel>
            <FormGroup>
              <TextField
                onChange={(e: any) => {
                  setProfile({ ...profile, name: e.target.value });
                }}
                value={profile.name}
                label="Profile Name"
                size="small"
                variant="outlined"
              />
            </FormGroup>
          </FormControl>
        </Box>
      </Container>
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button onClick={handleBack} disabled sx={{ mr: 1 }}>
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />
        <Button onClick={handleNext} disabled={profile.name.length === 0}>
          Next
        </Button>
      </Box>
    </>
  );
};

export default AddProfileName;
